import { render } from "./order_item.vue?vue&type=template&id=4b3b51da"
import script from "./order_item.vue?vue&type=script&lang=js"
export * from "./order_item.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/source/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__